import {
  ConnectedPosition,
  Overlay,
  ScrollStrategy
} from '@angular/cdk/overlay';
import { inject, InjectionToken } from '@angular/core';

export enum EVENT_TYPES {
  ONFOCUS = 'ONFOCUS',
  ONBLUR = 'ONBLUR'
}

export const ERROR_CODE = 'Please enter a valid city code or airport name';

export const PREDICTIVE_SEARCH_SCROLL_STRATEGY = new InjectionToken<
  () => ScrollStrategy
>('mach-predictive-search-scroll-strategy', {
  providedIn: 'root',
  factory: () => {
    const overlay = inject(Overlay);
    return () =>
      overlay.scrollStrategies.reposition({
        autoClose: false
      });
  }
});

export const ListOptionsPosition: ConnectedPosition[] = [
  {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top'
  }
];
